import { useEffect, useState } from "react";
import { Flex, Input, Text } from "@paguelofacil/pf-components";

import { emailSupportPf, emailValidate } from "../../services/utils/Validations";

import "../../assets/scss/inputs.scss";

export const InputTextEmail = ({ name, label, placeholder, disabled, onChangeValue, isRequired, defaultValue }) => {
    const [value, setValue] = useState(null);
    const [error, setError] = useState(null);

    const onChange = valueInput => {
        const inputValue = valueInput;

        const emailSupportPfError = emailSupportPf(inputValue);
        const emailValidationError = emailValidate(inputValue);

        if (emailSupportPfError || emailValidationError) {
            setError(emailSupportPfError || emailValidationError);
            onChangeValue(null);
        } else {
            setError(null);
            onChangeValue(inputValue);
        }

        if (!inputValue) {
            setError("Campo requerido");
        }
        setValue(inputValue);
    };

    useEffect(() => {
        console.log("defaultValue InputTextEmail", defaultValue);
        if (defaultValue) {
            onChange(defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultValue]);

    return (
        <Flex direction="column" align="stretch" gap="0.25rem">
            <Input
                defaultValue={defaultValue}
                className="inputs"
                labelClassName="input-label"
                variant="text"
                onChange={onChange}
                value={value}
                placeholder={placeholder}
                isDisabled={disabled}
                name={name}
                isRequired={isRequired}
                label={label}
                id="input-email"
                showHint={error}
                hint={
                    error ? (
                        <Text variant="caption" weight="regular" color="red">
                            {error}
                        </Text>
                    ) : (
                        <></>
                    )
                }
            />
        </Flex>
    );
};
